import axios from "../axios";
import { BASE_URL } from "@src/utils";
import { IReqSendChatMessage } from "@src/queries/chatQuery";

//웨딩홀 자동 채팅 발송
export const postHallInquiryChat = async (hallName: string) => {
  try {
    const params = {
      hallName: hallName,
      type: "RESERVATION",
    };
    const res = await axios.post(`${BASE_URL}/v4/20240927/hall/reservation/abandon/chat`, params);
    return res.data;
  } catch (err) {
    console.log(err);
  }
};

//할인 견적 자동 채팅 발송
export const postHallDiscountInquiryChat = async (hallName: string) => {
  try {
    const params = {
      hallName: hallName,
      type: "DISCOUNT_ESTIMATE_INQUIRY",
    };
    const res = await axios.post(`${BASE_URL}/v4/20240927/hall/reservation/abandon/chat`, params);
    return res.data;
  } catch (err) {
    console.log(err);
  }
};

//맞춤추천 이탈 시 채팅 발송
export const postRecommendHallInquiryChat = async () => {
  try {
    const params = {
      type: "RECOMMENDATION",
    };
    const res = await axios.post(`${BASE_URL}/v4/20240927/hall/reservation/abandon/chat`, params);
    return res.data;
  } catch (err) {
    console.log(err);
  }
};

//1:1문의 채팅 채널 조회
export const getChatChannelUuid = async (customerUuid: string) => {
  const meResponse = await axios.get<{
    item: {
      bookChatChannelUuid: string;
    };
  }>(`${BASE_URL}/web/v1/me?uuid=${customerUuid}`);
  return meResponse.data.item.bookChatChannelUuid;
};

interface IWeddingbookChatList {
  content: string;
  data: string | null;
  id: number;
  imageUrl: string | null;
  linkData: string | null;
  linkIcon: null | string;
  linkUrl: string | null;
  memberUuid: string | null;
  missed: boolean;
  regTsp: string;
  speaker: number;
  state: number;
  type: number;
  url: string | null;
}
//1:1문의 채팅 목록 조회
export const getWeddingbookChatList = async (channelUuid, customerUuid) => {
  const apiKey = "6VpljtKd7uXpQAFHrOClK90gi34tZlTkwoET7nA99dg%3D";
  const res = await axios.get<{ item: IWeddingbookChatList[] }>(
    `${BASE_URL}/v1/channel/${channelUuid}/chat?apiKey=${apiKey}&uuid=${customerUuid}&fetchStart=0&fetchSize=1000`,
  );
  return res.data;
};

//1:1문의 채팅 보내기
export const postWeddingbookChatList = async (channelUuid, params: IReqSendChatMessage) => {
  const apiKey = "6VpljtKd7uXpQAFHrOClK90gi34tZlTkwoET7nA99dg%3D";

  // URL 쿼리 파라미터 구성
  let url = `${BASE_URL}/v1/channel/${channelUuid}/chat?apiKey=${apiKey}&uuid=${params.uuid}`;

  // content가 있으면 쿼리 파라미터로 추가
  if (params.content) {
    url += `&content=${encodeURIComponent(params.content)}`;
  }

  // imageUrl이 있으면 쿼리 파라미터로 추가
  if (params.imageUrl) {
    url += `&imageUrl=${encodeURIComponent(params.imageUrl)}`;
  }

  // linkData가 있으면 쿼리 파라미터로 추가
  if (params.linkData) {
    url += `&linkData=${encodeURIComponent(params.linkData)}`;
  }

  // body 없이 POST 요청 (모든 데이터는 URL 쿼리 파라미터로 전달)
  const res = await axios.post(url);
  return res.data;
};
